import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseCaptionDescription = {
  rowGap: css`var(--cse-caption-description-row-gap, ${csSpacing.spacing04})`,
}

export const style: CSSResult = css`
  .cse-caption-description {
    display: flex;
    flex-direction: column;
    row-gap: ${cseCaptionDescription.rowGap};
  }

  .inverted {
    flex-direction: column-reverse;
  }

  .alignment-left {
    text-align: left;
  }

  .alignment-right {
    text-align: right;
  }
`
